import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Integrations } from "./Integrations";
import { Connectors } from "./Connectors";
import { useAppDataContext } from "../../framework/app/app.data.context";
import { Marketplace } from "./Marketplace";
import { getConfig } from "../../framework/config/app.config";

const csApiUrl = getConfig('VITE_BASE_URL');

export interface EmbedConfig {
  embedUrl: string; 
  embedToken: string;
  
}
export const Integrate: React.VFC = () => {
  const [value, setValue] = useState(0);
  const [config, setConfig] = useState<any>(null);
  const { appContext } = useAppDataContext();

  useEffect(() => {
    const getEmbedConfig = async () => {
      if (!appContext?.httpClient) return;
      const { httpClient } = appContext;

      try {
        const apiUrl = `${csApiUrl}/integration/getEmbeddedIntegrationPlatformConfig`;
        const { body } = await httpClient(apiUrl);
        const data:EmbedConfig = JSON.parse(body);
        console.log('data', data);
        setConfig(data);
      } catch (error) {
        console.error("Failed to fetch config:", error);
      }
    };

    getEmbedConfig();
  }, [appContext]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  if (!config) {
    return <div>Loading...</div>;
  }


  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Connectors" />
          <Tab label="Integrations" />
          <Tab label="Compositions" />
        </Tabs>
      </Box>

      {value === 0 && <Connectors {...config} />}
      {value === 1 && <Marketplace {...config}/>}
      {value === 2 && <Integrations {...config}/>}
      </>
  );
};